define('pimProductDetailImageView',[
  'module',
  'marionette',
  'underscore',
  'template!pimProductDetailImageView',
  'pimPicturePlaced'
], function (
  Module,
  Marionette,
  _,
  Tpl,
  Placed
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'pim-products-details-image-view',

    serializeData: function () {
      var data = {};
        data.src = '';

        if(this.model.get('imageUrl'))
          data.src = this.model.get('imageUrl');

      var resProduct = this.options.pimProduct ? this.options.pimProduct.getCurrentResProduct() : null;
      var placed = Placed.onPicture(resProduct ? resProduct.get('pimPicturePositions') : [], null, null,
        data.src, this.model.get('productPicturePositions'));
      data.placed = placed ? _.extend({title: Placed.title(placed)}, placed) : null;

      return data;
    },
  
    onRender: function () {
      if(this.model.get('color')) {
        this.$el.css('background-color', this.model.get('color'));
        this.$el.attr('title', this.model.get('name'));
      }
    }
  });
});
